import { useState } from "react";

const testimonials = [
  {
    name: "Maria Aparecida S.",
    role: "Paciente há 3 anos",
    text: "Fiz prótese dentária e fiquei impressionada com a qualidade e o preço. Parcelei em 24x sem entrada e o laboratório da própria clínica entregou em dias. Atendimento nota 10!",
    rating: 5,
    avatar: "https://public.readdy.ai/ai/img_res/f5333857df2f61ec30a12f39ea248e2e.jpg",
  },
  {
    name: "Carlos Eduardo M.",
    role: "Paciente há 1 ano",
    text: "Precisei de emergência num sábado e fui atendido rapidamente. O dentista foi super cuidadoso, sem dor nenhuma. O crédito foi aprovado na hora e já saí com o tratamento feito!",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20Brazilian%20man%20in%20his%2035s%20smiling%20warmly%2C%20simple%20clean%20white%20background%2C%20natural%20lighting%2C%20realistic%20photo%2C%20professional%20look&width=80&height=80&seq=av002&orientation=squarish",
  },
  {
    name: "Fernanda Lima",
    role: "Paciente há 2 anos",
    text: "Trouxe toda minha família. Meus filhos adoram a dentista deles, que é muito paciente e carinhosa. Os preços são muito mais acessíveis do que outros lugares. Indico a todos!",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20Brazilian%20woman%20in%20her%2030s%20with%20a%20beautiful%20smile%2C%20simple%20background%2C%20natural%20lighting%2C%20realistic%20photo%2C%20relatable%20person&width=80&height=80&seq=av003&orientation=squarish",
  },
  {
    name: "Roberto A.",
    role: "Paciente há 6 meses",
    text: "Fiz clareamento e ficou incrível! Processo rápido, confortável e com resultado excelente. O preço é justo e eles parcelam sem burocracia. Recomendo muito!",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20smiling%20Brazilian%20man%20in%20his%2040s%20with%20bright%20smile%2C%20simple%20neutral%20background%2C%20natural%20lighting%2C%20casual%20look%2C%20realistic%20photo&width=80&height=80&seq=av004&orientation=squarish",
  },
  {
    name: "Ana Paula T.",
    role: "Paciente há 4 anos",
    text: "Fiz a radiografia, a avaliação e já iniciei o tratamento tudo no mesmo dia! A equipe é incrível, atenciosa e o ambiente é muito limpo e agradável. Melhor clínica da região!",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20Brazilian%20woman%20in%20her%2045s%20with%20a%20joyful%20smile%2C%20simple%20background%2C%20natural%20lighting%2C%20realistic%20photo%2C%20friendly%20expression&width=80&height=80&seq=av005&orientation=squarish",
  },
  {
    name: "João Batista F.",
    role: "Paciente há 2 anos",
    text: "Estava com muito medo de dentista mas a equipe foi tão acolhedora que me senti à vontade. Fizeram a extração sem dor e ainda parcelamos sem juros. Voltarei sempre!",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20middle-aged%20Brazilian%20man%20smiling%20relieved%20and%20happy%2C%20simple%20background%2C%20natural%20lighting%2C%20realistic%20photo%2C%20relaxed%20expression&width=80&height=80&seq=av006&orientation=squarish",
  },
];

export default function TestimonialsSection() {
  const [activeIdx, setActiveIdx] = useState(0);

  return (
    <section id="depoimentos" className="py-16 md:py-24 bg-primary-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-16">
          <span className="text-secondary font-semibold text-sm uppercase tracking-widest">O que dizem nossos pacientes</span>
          <h3 className="text-2xl md:text-4xl font-extrabold text-primary-700 mt-3 mb-4">
            Histórias Reais, Sorrisos Reais
          </h3>
          <p className="text-gray-500 max-w-lg mx-auto text-sm md:text-base">
            Mais de 15.000 pacientes confiaram na Primor. Veja o que eles dizem.
          </p>
        </div>

        {/* Google Rating bar */}
        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 mb-8 md:mb-12">
          <div className="flex items-center gap-1">
            {[1,2,3,4,5].map((s) => (
              <i key={s} className="ri-star-fill text-yellow-400 text-lg md:text-xl"></i>
            ))}
          </div>
          <p className="text-primary-700 font-bold text-lg md:text-xl">4.9</p>
          <p className="text-gray-400 text-xs md:text-sm">+450 avaliações no Google</p>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={t.name}
              className={`bg-white rounded-2xl p-6 border transition-all cursor-pointer ${
                activeIdx === idx ? "border-primary-300 shadow-md" : "border-gray-100"
              }`}
              onClick={() => setActiveIdx(idx)}
            >
              <div className="flex mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-5 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="font-bold text-primary-700 text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
